import { config } from "../../../../config/domain";
export const segmentDeactivationMsg = Object.freeze({
    error: "There was some problem in raising service request. Please try again later.",
    createSR: {
      content : "We have received your request! Following segments will be deactivated in 2 working days:",
      redirectionText: "Back to Homepage",
      redirectionLink: config.rootUrl + "clientarea/servicerequest",
    },
    SRexists: {
      headerText: "You have an active service request",
      content: "You have already raised this request for the day.",
    }
});

  export const errorMsg = {
    openOrder: {
      err: "Please cancel your open orders to proceed with Segment deactivation.",
      msg: "to cancel open orders.",
      link: config.rootUrl + "?ottype=order-status"
    },
    openSIP: {
        err: "Please ensure there is no running SIP in your account to proceed with Segment deactivation.",
        msg: "to stop the SIP.",
        link: config.rootUrl + "?ottype=order-status&sTab=3"
    },
    openPosition: {
        err: "Please close your open positions to proceed with Segment deactivation.",
        msg: "to close open positions.",
        link: config.rootUrl + "?ottype=my-positions"
    }
}

  export const allowedSegmentsEQ = ['NSEFO', 'BSEFO', 'NSECDS', 'BSECDS', 'BSEMFSS'];
  export const allowedSegmentsCOM = ['COMMCX', 'COMNCDEX'];
  export const allowedSegmentsComEq = ['NSEFO','BSEFO', 'NSECDS','BSECDS', 'BSEMFSS', 'COMMCX', 'COMNCDEX'];
  export const segmentNamesSMS = {
    NSEFO: "Equity Derivatives",
    BSEFO: "Equity Derivatives",
    NSECDS: "Currency Derivatives",
    BSECDS: "Currency Derivatives",
    BSEMFSS: "Mutual Funds",
    COMMCX: "",
    COMNCDEX:"Commodity Derivatives"
  }
  export const eqDerivatives = ['OPTIDX','OPTSTK','FUTIDX','FUTSTK'];
  export const curDerivatives = ['OPTCUR','FUTCUR'];
